import { pxNumber } from "../../mixins/formatters";
import { canvasBoxShadowSize, minCanvasSize, transition } from "./config";
// Define values depending on the OffCanvas position
export const positionPropsMap = (motionValue) => ({
    bottom: {
        animations: {
            visible: {
                y: 0,
                transition,
            },
            hidden: (size) => {
                return {
                    y: size?.height
                        ? size.height + pxNumber(canvasBoxShadowSize)
                        : `calc(100% + ${canvasBoxShadowSize}px)`,
                    transition,
                };
            },
            swipedExit: (size) => ({
                y: size?.height
                    ? size.height + pxNumber(canvasBoxShadowSize)
                    : `calc(100% + ${canvasBoxShadowSize}px)`,
            }),
        },
        dragConstraints: {
            top: 0,
        },
        dragDirection: "y",
        canvasStyle: { minHeight: minCanvasSize, y: motionValue },
        curtainProps: { _flexDirection: "column" },
    },
    top: {
        animations: {
            visible: {
                y: 0,
                transition,
            },
            hidden: (size) => ({
                y: size?.height
                    ? -1 * size.height - pxNumber(canvasBoxShadowSize)
                    : `calc(-100% - ${canvasBoxShadowSize}px)`,
                transition,
            }),
            swipedExit: (size) => ({
                y: size?.height
                    ? -1 * size.height - pxNumber(canvasBoxShadowSize)
                    : `calc(-100% - ${canvasBoxShadowSize}px)`,
            }),
        },
        dragConstraints: {
            bottom: 0,
        },
        dragDirection: "y",
        canvasStyle: { minHeight: minCanvasSize, y: motionValue },
        curtainProps: { _flexDirection: "column", _justifyContent: "flex-start" },
    },
    right: {
        animations: {
            visible: {
                x: 0,
                transition,
            },
            hidden: (size) => ({
                x: size?.width
                    ? size.width + pxNumber(canvasBoxShadowSize)
                    : `calc(100% + ${canvasBoxShadowSize}px)`,
                transition,
            }),
            swipedExit: (size) => ({
                x: size?.width
                    ? size.width + pxNumber(canvasBoxShadowSize)
                    : `calc(100% + ${canvasBoxShadowSize}px)`,
            }),
        },
        dragConstraints: {
            left: 0,
        },
        dragDirection: "x",
        canvasStyle: { minWidth: minCanvasSize, x: motionValue },
        curtainProps: { _flexDirection: "row", _justifyContent: "flex-end" },
    },
    left: {
        animations: {
            visible: {
                x: 0,
                transition,
            },
            hidden: (size) => ({
                x: size?.width
                    ? -1 * size.width - pxNumber(canvasBoxShadowSize)
                    : `calc(-100% - ${canvasBoxShadowSize}px)`,
                transition,
            }),
            swipedExit: (size) => ({
                x: size?.width
                    ? -1 * size.width - pxNumber(canvasBoxShadowSize)
                    : `calc(-100% - ${canvasBoxShadowSize}px)`,
            }),
        },
        dragConstraints: {
            right: 0,
        },
        dragDirection: "x",
        canvasStyle: { minWidth: minCanvasSize, x: motionValue },
        curtainProps: { _flexDirection: "row", _justifyContent: "flex-start" },
    },
});
//# sourceMappingURL=data:application/json;base64,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